<ul class="bs-nav bs-navbar-nav bs-ml-auto">
    <li class="nav-item bs-dropdown d-md-down-none">
        <a class="bs-nav-link" [routerLink]="['/email']" style="cursor:pointer; user-select: none;">
            <i class="fa fa-envelope"></i>
            <span class="bs-badge bs-badge-primary">{{notificationCount | async}}</span>
        </a>
    </li>
</ul>
